import React, { Component } from 'react';
import { Form, Col, Button } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa'
class Work extends Component {
    state={
        present:false
        }
    render() {
        const [parentState, parentSetState, index] = this.props.state
        const company = parentState.find(item => item.id === index)
        return (
            <div className="workContainer">

                <Form>
                    <div>
                        <Form.Row>
                            <Form.Group as={Col} lg={7} md={7} sm={12} xs={12} controlId="formGridEmail">
                                <Form.Label>Company Name</Form.Label>
                                <Form.Control
                                    value={company.name}
                                    onChange={(e) => {
                                        const newState = [...parentState]
                                        const modIndex = newState.findIndex(item => item.id === index)
                                        newState[modIndex].name = e.target.value
                                        parentSetState({ companyDetails: newState })
                                    }}
                                    type="text" required placeholder="eg. Name of Company" />
                            </Form.Group>

                            <Form.Group as={Col} lg={5} md={5} sm={12} xs={12} controlId="formGridPassword">
                                <Form.Label>Role</Form.Label>
                                <Form.Control
                                    value={company.role}
                                    onChange={(e) => {
                                        const newState = [...parentState]
                                        const modIndex = newState.findIndex(item => item.id === index)
                                        newState[modIndex].role = e.target.value
                                        parentSetState({ companyDetails: newState })
                                    }}
                                    type="text" required placeholder="eg. Internship" />
                            </Form.Group>
                        </Form.Row>

                        <Form.Row>
                            <Form.Group as={Col} md={4} lg={3} sm={12} xs={12} controlId="formGridEmail">
                                <Form.Label>From</Form.Label>
                                <Form.Control
                                    value={company.from}
                                    onChange={(e) => {
                                        const newState = [...parentState]
                                        const modIndex = newState.findIndex(item => item.id === index)
                                        newState[modIndex].from = e.target.value
                                        parentSetState({ companyDetails: newState })
                                    }}
                                    type="date" required />
                            </Form.Group>

                            <Form.Group as={Col} md={4} lg={3} sm={12} xs={12} controlId="formGridPassword">
                                <Form.Label>To</Form.Label>
                                <Form.Control
                                    value={company.to}
                                    onChange={(e) => {
                                        const newState = [...parentState]
                                        const modIndex = newState.findIndex(item => item.id === index)
                                        newState[modIndex].to = e.target.value
                                        this.setState({present:false})                                       
                                        parentSetState({ companyDetails: newState })
                                    }}
                                    type="date" required disabled={company.to!=="Present"?false:true}/>
                            </Form.Group>

                        </Form.Row>
                        <Form.Group controlId="formBasicCheckbox">
                            <Form.Check  defaultChecked={company.to==="Present"?true:false} value={company.to} type="checkbox" label="I'm currently working here !!!" 
                            onClick={(e) => {
                                if(company.to==="Present"){
                                    company.to=""                                   
                                    this.setState({present:false})
                                }
                                else{const newState = [...parentState]
                                    const modIndex = newState.findIndex(item => item.id === index)
                                    newState[modIndex].to = "Present"
                                    this.setState({present:true})                                    
                                    parentSetState({ companyDetails: newState })}                                
                            }}/>
                                </Form.Group>

                    </div>
                    <Button
                        onClick={this.props.deleteHandler}
                        variant="danger" size="sm">
                        <FaTrash />
                    </Button>
                </Form>
            </div>


        )
    }
}

export default Work;